import React from "react";
import MoreButton from "./MoreButton";

const FeatureAgentHead = () => {
    return (
        <div className="relative overflow-hidden bg-white">
            <div className="pt-16 pb-16  sm:pt-24 sm:pb-40 lg:pt-40 lg:pb-40">
                <div className="relative mx-auto max-w-7xl px-5 sm:static sm:px-10 lg:px-8 flex align-top justify-between sm:flex-row flex-col gap-8 lg:gap-4">
                    <div className="sm:max-w-lg">
                        <h1 className="text-h1 font-bold tracking-tight text-gray-900">
                            세일즈포스 에이전트포스
                        </h1>
                        <p className="mt-4 font-bold text-brand text-h3 lg:max-w-[460px]">
                            Salesforce 플랫폼에서 맞춤형 에이전트를 구축,{" "}
                            <span className="whitespace-nowrap">
                                사람+AI+데이터+업무를
                            </span>{" "}
                            결합하는 유일한 존재, Agentforce
                        </p>
                        <p className="mt-4 text-balance text-gray-500 text-body">
                            &quot;Agentforce는 직원이나 고객에게 전문적 지원을 제공하는
                            능동형 및 자율형 애플리케이션입니다. <br/> 이 에이전트들은 각자의 역할에 맞는 비즈니스 지식을 갖추고
                            있어, 비즈니스의 특정 업무를 효율적으로 수행할 수 있습니다.&quot;
                        </p>
                        <MoreButton className="mt-10" />
                    </div>

                    <div className="rounded-[30px] overflow-hidden">
                        <img
                            src="/img/salesforce/agent-main-banner.jpg"
                            alt=""
                            className="h-full w-full object-cover object-center"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FeatureAgentHead;
